/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_ConvertingInputs */

const en_mobile_converting = /** @type {(inputs: Mobile_ConvertingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converting…`)
};

const es_mobile_converting = /** @type {(inputs: Mobile_ConvertingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convirtiendo…`)
};

/**
* | output |
* | --- |
* | "Converting…" |
*
* @param {Mobile_ConvertingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_converting = /** @type {((inputs?: Mobile_ConvertingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_ConvertingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_converting(inputs)
	return en_mobile_converting(inputs)
});